module.exports = __webpack_public_path__ + "img/confirmed-icon.c5dc9cdb.svg";